/**
 * Imports only components, but no theme
 *
 */

import './themes/theme-ui/ui-theme-components.scss'
